module.exports = __webpack_public_path__ + "components/MapControl/svg/Trasa biegowa.svg?b2fb2ce4";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Trasa biegowa.svg
// module id = 2042
// module chunks = 0